<script setup>
import IconBase from '../icon/IconBase.vue'
import IconPlay from '../icon/IconPlay.vue'
import IconPlus from '../icon/IconPlus.vue'
import IconBookOpen from '../icon/IconBookOpen.vue'
import FormButton from '../Atoms/FormButton.vue'
import IconTV from '../icon/IconTV.vue'
import EmptyState from '../ui/EmptyState.vue'

const emit = defineEmits(['createPlayout', 'showDemo'])

const showCreatePlayoutModal = () => emit('createPlayout')
const showDemo = () => emit('showDemo')
</script>

<template>
	<EmptyState title="Create your first TV Playout"
		subtitle="Schedule your videos and live sources to play back to back as an always-on channel that runs 24/7, like your own TV station.">
		<template #icon>
			<icon-base width="28" height="28">
				<IconTV />
			</icon-base>
		</template>
		<template #actions>
			<FormButton size="lg" type="main" @click="showCreatePlayoutModal">
				<icon-base class="mr-2">
					<icon-plus />
				</icon-base>
				New Playout
			</FormButton>
			<div class="flex items-center gap-5 mt-4">
				<a href="https://docs.castr.com/en/articles/8001118-create-your-tv-playout" target="_blank" rel="noopener"
					class="text-tiny text-surface-7 hover:text-white transition-colors inline-flex items-center gap-1.5">
					<icon-base>
						<icon-book-open />
					</icon-base>
					How TV Playout works
				</a>
				<FormButton @click="showDemo"
					custom-classes="text-tiny text-surface-7 hover:text-white transition-colors inline-flex items-center gap-1.5">
					<icon-base>
						<icon-play />
					</icon-base>
					Watch a tutorial
				</FormButton>
			</div>
		</template>
	</EmptyState>
</template>
